import { InfoSection } from '@components'

import { Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { DK_AUTHORITY_URL } from '../../../../consts/taxAuthoritiesUrls'

export const ModalBodyDK = (): ReactElement => {
  const { t } = useTranslation()

  const infoText = (
    <Trans i18nKey="vat_declarations.settlement_modal.modal_body.body_info_dk" value="test">
      Please note that you must submit the figures to SKAT yourself via
      <Link href={DK_AUTHORITY_URL} target="_blank" rel="noreferrer">
        TastSelv
      </Link>
    </Trans>
  )

  return (
    <>
      <Text>{t('vat_declarations.settlement_modal.modal_body.body_text_dk')}</Text>
      <InfoSection infoText={infoText} />
    </>
  )
}
